import React from 'react';
import { ArrowRight } from 'lucide-react';
export function RelatedServices() {
  const services = [{
    title: 'Residential Glass',
    copy: 'Broken windows, door glass, custom glass and other residential glass services.',
    link: '/residentialglass.html'
  }, {
    title: 'Window Glass',
    copy: 'Glass-only window replacement, foggy double-pane glass and broken window glass.',
    link: '/windowglass.html'
  }, {
    title: 'Custom Mirrors',
    copy: 'Bathroom mirrors, vanity mirrors, wall mirrors and home gym mirrors.',
    link: '/customglassmirrors.html'
  }, {
    title: 'Glass Deck Railing',
    copy: 'Custom glass railing panels for decks and outdoor views.',
    link: '/deckglass.html'
  }, {
    title: 'Euro Glass Shower Doors',
    copy: 'Dedicated Euro-style frameless shower door details and inspiration.',
    link: '/euroglasshowerdoors.html'
  }];
  return <section className="py-16 bg-gray-50 border-b border-gray-200" data-id="element-1484" data-mp="325zyl7zmxd80">
      <div className="container mx-auto px-4 max-w-7xl" data-id="element-1485" data-mp="vcruhfg8qomf">
        <div className="anim-on-scroll" data-id="element-1486" data-mp="qd5gv4wi36d3">
          <h2 className="text-2xl font-bold text-navy mb-8 text-center tracking-normal" data-id="element-1487" data-mp="qbarnee74s37">
            More Custom Glass for Your Home
          </h2>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4" data-id="element-1488" data-mp="hcpc7s40tt6n">
          {services.map((svc, i) => <a key={i} href={svc.link} className="block bg-white p-5 rounded-lg border border-gray-100 hover:border-primary hover:shadow-md transition-all group h-full scroll-fade-up" style={{
          animationDelay: `${i * 0.05}s`
        }} data-id="element-1489" data-mp="1e1ew1nz7kvv9" data-mpi={i}>
              <h3 className="font-bold text-navy mb-2 group-hover:text-primary transition-colors flex items-center justify-between" data-id="element-1490" data-mp="10atatsma89u7">
                {svc.title}
                <ArrowRight className="w-4 h-4 opacity-0 group-hover:opacity-100 transition-opacity -translate-x-2 group-hover:translate-x-0" data-id="element-1491" data-mp="1s1zbca5x09k0" />
              </h3>
              <p className="text-sm text-gray-500" data-id="element-1492" data-mp="3r96e8x2tx125">{svc.copy}</p>
            </a>)}
        </div>
      </div>
    </section>;
}